import { pick } from "lodash";
import * as yup from "yup";
import es from "yup-es";
import { parseProductOptionsToEntries } from "../shared/parse";

yup.setLocale(es);

export const getSchema = (fields: string[]) =>
  yup.object().shape(
    pick(
      {
        sku: yup.string().required(),
        name: yup.string().required(),
        description: yup.string().required(),
        longDescription: yup.string(),
        retailPrice: yup.number().required().positive(),
        barCode: yup.string().required(),
        height: yup.number().required().positive(),
        width: yup.number().required().positive(),
        length: yup.number().required().positive(),
        weight: yup.number().required().positive(),
        status: yup.boolean().required(),
        // Product-group option validation was deprecated; the field is kept (it
        // feeds serialize) but no longer validated against a product group,
        // which removes the GET /api/products/v2/group/{id} call (the source of
        // the /v2/group/undefined 404s).
        productOptions: yup.string(),
      },
      fields
    )
  );

export const serialize = async (payload: any) => {
  let { ...rest }: any = payload;

  if ("productOptions" in payload) {
    const productOptions = Object.fromEntries(
      parseProductOptionsToEntries(payload.productOptions as string)
    );
    rest = { ...rest, productOptions };
  }

  return rest;
};
